import {baseApi} from "../baseApi";
import {IDailyReconciliationsResponse, IUpdateBody,} from "./types";

const endpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDailyReconciliations: builder.query<IDailyReconciliationsResponse, number|undefined>({
            query: (page) => ({
                url: `api/adm/reconciliations`,
                method: 'GET',
                params:{
                    page:page!==0?page:undefined
                }
            }),
            providesTags: ['daily_reconciliations']

        }),
        updateDailyReconciliationsVisit: builder.mutation<any, IUpdateBody>({
            query: ({id, body}) => ({
                url: `api/adm/appointments/${id}/update `,
                method: 'PUT',
                body:body
            }),
            invalidatesTags: ['daily_reconciliations','reconciliations']

        }),

    })
})

export const {
    useGetDailyReconciliationsQuery,
    useUpdateDailyReconciliationsVisitMutation
} = endpoints